import * as Icons from "lucide-react";
import { useLang } from "@/context/LangContext";

const FALLBACK_ICON = "Sparkles";

export default function Services({ services }) {
  const { t, pick } = useLang();

  return (
    <section id="services" className="afb-section bg-afb-bg" data-testid="services-section">
      <div className="afb-container">
        <div className="max-w-2xl mb-10 sm:mb-14">
          <span className="afb-eyebrow">{t("sections.services_label")}</span>
          <h2 className="serif text-[1.7rem] sm:text-3xl md:text-4xl lg:text-5xl mt-3 leading-[1.15] text-afb-ink">
            {t("sections.services_subtitle")}
          </h2>
          <span className="block mt-5 h-[2px] w-16 sm:w-20 bg-[color:var(--afb-gold)]" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
          {services.map((s) => {
            const Icon = Icons[s.icon] || Icons[FALLBACK_ICON];
            return (
              <article
                key={s.id}
                className="afb-card group"
                data-testid={`service-card-${s.id}`}
              >
                <div className="flex items-start justify-between mb-5">
                  <div className="w-12 h-12 rounded-full bg-[color:var(--afb-cream)] flex items-center justify-center text-afb-gold group-hover:bg-afb-gold group-hover:text-white transition-colors">
                    <Icon className="w-5 h-5" strokeWidth={1.6} />
                  </div>
                  <span className="text-[10px] uppercase tracking-[0.22em] text-afb-gold border border-[color:var(--afb-gold)] rounded-full px-2 py-0.5">
                    {t("common.h24")}
                  </span>
                </div>
                <h3 className="serif text-xl text-afb-ink leading-snug">
                  {pick(s, "title")}
                </h3>
                {pick(s, "description") && (
                  <p className="mt-3 text-sm text-afb-muted leading-relaxed">
                    {pick(s, "description")}
                  </p>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
